import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

export const selectUserState = createSelector((state: RootState) => state, (state) => state.user)
export const getCurrentUser = createSelector(selectUserState, (state) => state.currentUser)
export const selectLoggedInUserPid = createSelector(selectUserState, (state) => state.currentUser?.data?.samaccountname)
export const selectLoggedInUserEmail = createSelector(selectUserState, (state) => state.currentUser?.data?.Email)
export const isPowerUserSelector = createSelector(selectUserState, (state) => {
    const memberof = state.currentUser?.data?.Memberof;
    if (Array.isArray(memberof)) {
        return memberof.some((n: string) => n?.toLowerCase()?.startsWith('ap-sr-msm') && n?.toLowerCase()?.includes('powerusers'));
    }
    return typeof memberof === 'string' && memberof && memberof.toLowerCase().startsWith('ap-sr-msm') && memberof.toLowerCase().includes('powerusers');
})


export { }